var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.markdownText()),expression:"markdownText()"}],staticClass:"pt-4 text-mk"})}
var staticRenderFns = []

export { render, staticRenderFns }